import { initReactI18next } from "react-i18next";

import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import LocizeBackend from "i18next-locize-backend";

import enFallback from "./enFallback.json";

const locizeOptions = {
  referenceLng: "tr",
  projectId: "f07b7de3-164a-4335-9476-ebc64fbac570",
  apiKey: import.meta.env.VITE_LOCIZE_API_KEY,
};

i18n
  .use(LocizeBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "tr",
    keySeparator: false,
    nsSeparator: false,
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
      convertDetectedLanguage: (lng) =>
        lng.indexOf("-") > -1 ? lng.toLowerCase().split("-")[0] : lng,
    },
    interpolation: {
      escapeValue: false,
    },
    backend: locizeOptions,
    saveMissing: true,
    react: {
      useSuspense: true,
    },
  });

/**
 * Locize'da İngilizce karşılığı henüz girilmemiş anahtarlar için yerel yedek.
 *
 * `fallbackLng: "tr"` olduğu için böyle bir anahtar İngilizce arayüzde Türkçe
 * görünüyor; ekranda İngilizce ve Türkçe metinler karışıyordu. Bu yedek yalnızca
 * boşlukları doldurur, Locize'daki çeviriyi hiçbir zaman ezmez.
 *
 * <b>Neden init'e `resources` olarak verilmedi:</b> i18next bir dil/namespace için
 * store'da bundle görürse onu "yüklendi" sayıyor
 * (`BackendConnector.queueLoad` → `hasResourceBundle`) ve Locize'dan hiç çekmiyor —
 * yani Locize'daki TÜM İngilizce çeviriler kaybolurdu. `partialBundledLanguages`
 * bile bu kontrolü atlatmıyor. Bu yüzden yedek, Locize yüklemesi bittikten SONRA
 * ekleniyor: `deep = true, overwrite = false` → yalnızca var olmayan anahtarlar yazılır.
 *
 * Yeni bir anahtarın kalıcı yeri hâlâ Locize; buradaki metin çeviri girilene kadar
 * geçerli olur, girildiği anda Locize'daki kazanır.
 */
const applyEnglishFallback = () => {
  // Locize henüz en'i yüklemediyse dokunmuyoruz: bundle'ı burada oluşturmak
  // yükleme atlanmasına yol açar (yukarıdaki gerekçe).
  if (!i18n.hasResourceBundle("en", "translation")) return;
  i18n.addResourceBundle("en", "translation", enFallback, true, false);
};

// "loaded" her başarılı backend yüklemesinden sonra tetiklenir ve changeLanguage'in
// "languageChanged" yayınından ÖNCE gelir; yedek ilk render'dan önce yerine oturur.
i18n.on("loaded", applyEnglishFallback);

export default i18n;
